import { render, staticRenderFns } from "./categories-type-2.vue?vue&type=template&id=1bff610c&"
import script from "./categories-type-2.vue?vue&type=script&lang=ts&"
export * from "./categories-type-2.vue?vue&type=script&lang=ts&"
import style0 from "./categories-type-2.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports